import { setCookie } from './';
import { getUrlParameter } from './';

export const setCampaignId = () => {
  const campaignId = getUrlParameter('campaignID') || '';
  setCookie('campaignId', JSON.stringify(campaignId));
};
